/**
 * File: Grid.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.1
 * Created: 2025-11-06
 * Last Updated: 2025-11-11
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function Grid({ items }) {
    return (
        <>
            <div className="grid">
                {items.map((item) => (
                    <GridItem
                        key={item.id}
                        Component={item.component}
                        props={item.props}
                        modifier={item.modifier}
                    />
                ))}
            </div>
        </>
    );
}

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function GridItem({ Component, props, modifier }) {
    return (
        <>
            <div className={`grid-item ${modifier}`}>
                <Component {...props} />
            </div>
        </>
    );
}

export default Grid;
